module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('app-sidebar'), _vm._v(" "), _c('router-view', {
    key: _vm.$route.fullPath
  }), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('control-sidebar'), _vm._v(" "), _c('banner-periodo-eleitoral')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7766e578!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 2024
// module chunks = 1